import { Player } from '../../../../hooks/useGame/types';
import DrinkIcon from '../../../Icons/DrinkIcon';
import InviteButton from '../../../InviteButton';

export type TGameInfo = {
  drinkCount: number | undefined;
  gameId: string | undefined;
  player: Player | null;
  numPlayers: number;
};

type Props = {
  gameInfo?: TGameInfo;
};

const GameInfo = ({ gameInfo }: Props) => {
  const { drinkCount, gameId, player } = gameInfo || {};

  return (
    <>
      <div className="flex flex-row items-center gap-4">
        {player && (
          <div className="flex flex-row gap-2">
            <span className="truncate max-w-[20vw] min-[375px]:max-w-[30vw] sm:max-w-[50vw]">
              {player.nickname}
            </span>
            <div className="flex flex-row">
              {drinkCount !== undefined && (
                <div>
                  <span>{drinkCount}</span>
                  <span>x</span>
                </div>
              )}
              <DrinkIcon icon={player.icon} size={24} />
            </div>
          </div>
        )}
        {gameId && <InviteButton gameId={gameId} />}
      </div>
    </>
  );
};

export default GameInfo;
